.field {
  display: grid;
  gap: 6px;
  margin-bottom: 12px;
}

.results {
  display: grid;
  gap: 6px;
  max-height: 280px;
  margin: 0 0 16px;
  padding: 0;
  overflow-y: auto;
  list-style: none;
}

.result {
  display: grid;
  width: 100%;
  gap: 2px;
  padding: 10px 12px;
  border: 1px solid var(--line);
  border-radius: var(--radius-field);
  background: transparent;
  color: var(--text);
  text-align: left;
  cursor: pointer;
}

.result:hover {
  border-color: var(--accent);
}

.meta {
  color: var(--muted);
  font-size: 13px;
}

.facts {
  display: grid;
  grid-template-columns: max-content 1fr;
  gap: 8px 16px;
  margin: 0 0 16px;
  font-size: 14px;
}

.row {
  display: contents;
}

.facts dt {
  color: var(--muted);
}

.facts dd {
  margin: 0;
}

.warnings {
  margin: 0 0 16px;
  padding-left: 18px;
  color: var(--muted);
  font-size: 14px;
  line-height: 1.5;
}
